module.exports = __webpack_public_path__ + "img/eye3.1021361b.svg";